export const THEME_OPTIONS = [
  { value: 'system', label: 'System' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
]

export const PR_DESTINATION_OPTIONS = [{ value: 'github', label: 'GitHub' }]

export const SESSIONS_PAGE_SIZE = 5

/** @type {{ id: string, device: string, created: string }[]} */
export const ACTIVE_SESSIONS_PLACEHOLDER = [
  { id: '1', device: 'Desktop App', created: 'About 1 month ago' },
  { id: '2', device: 'Web', created: 'About 1 month ago' },
  { id: '3', device: 'Desktop App', created: '24 days ago' },
  { id: '4', device: 'Desktop App', created: '24 days ago' },
  { id: '5', device: 'Desktop App', created: '22 days ago' },
  { id: '6', device: 'Web', created: '18 days ago' },
  { id: '7', device: 'Desktop App', created: '14 days ago' },
  { id: '8', device: 'Mobile', created: '12 days ago' },
  { id: '9', device: 'Web', created: '9 days ago' },
  { id: '10', device: 'Desktop App', created: '7 days ago' },
  { id: '11', device: 'IDE', created: '5 days ago' },
  { id: '12', device: 'Web', created: '3 days ago' },
  { id: '13', device: 'Desktop App', created: '2 days ago' },
  { id: '14', device: 'Web', created: '1 day ago' },
]
